export default "https://cdn-static.gokick.com/assets/d7539373fb86e46f3eed15b4b495ca9c5158faa3/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";